<template>
    <section class="gz-content">
        <section class="gz-content__container">
            <section class="gz-content__menu-container">
                <section class="gz-content__menu">
                    <slot name="menu"></slot>
                </section>
            </section>
            <section class="gz-content__body">
                <transition name="page-transition">
                    <slot name="body"></slot>
                </transition>
            </section>
        </section>
    </section>
</template>

<script>
export default {
    name: 'Content'    
}
</script>